<template>
  <el-container v-title data-title="日程设置" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学生点餐</el-breadcrumb-item>
                <el-breadcrumb-item>日程设置</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getStudentCanteenScheduleList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="140"></el-table-column>
          <el-table-column prop="startDate" label="学生就餐日期（开始）" width="170"></el-table-column>
          <el-table-column prop="endDate" label="学生就餐日期（结束）" width="170"></el-table-column>
          <el-table-column prop="bookTime" label="家长点餐时间（开始）" width="170"></el-table-column>
          <el-table-column prop="lockTime" label="家长点餐时间（结束）" width="170"></el-table-column>
          <el-table-column prop="creatorRealName" label="创建人" width="90"></el-table-column>
          <el-table-column prop="updaterRealName" label="修改人" width="90"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="openStatsDialog(scope.row)">统计</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getStudentCanteenScheduleList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="380px"
        :before-close="handleClose"
        append-to-body>
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="120px">
          <el-form-item label="学生就餐日期" prop="startDate">
            <el-date-picker
              v-model="addData.startDate"
              type="date"
              placeholder="请选择日期（开始）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-date-picker
              v-model="addData.endDate"
              type="date"
              placeholder="请选择日期（结束）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="家长点餐时间" prop="bookTime">
            <el-date-picker
              v-model="addData.bookTime"
              type="date"
              placeholder="请选择时间（开始）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-date-picker
              v-model="addData.lockTime"
              type="date"
              placeholder="请选择时间（结束）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addStudentCanteenSchedule">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="380px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="120px">
          <el-form-item label="学生就餐日期" prop="startDate">
            <el-date-picker
              v-model="modifyData.startDate"
              type="date"
              placeholder="请选择日期（开始）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-date-picker
              v-model="modifyData.endDate"
              type="date"
              placeholder="请选择日期（结束）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="家长点餐时间" prop="bookTime">
            <el-date-picker
              v-model="modifyData.bookTime"
              type="date"
              placeholder="请选择时间（开始）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-date-picker
              v-model="modifyData.lockTime"
              type="date"
              placeholder="请选择时间（结束）"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyStudentCanteenSchedule">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（统计） -->
      <el-dialog
        title="统计"
        :visible.sync="statsDialogVisible"
        width="950px"
        :before-close="handleClose">
        <el-button type="text" @click="downloadStatsByWeekMenuId()">下载</el-button>
        <el-tabs v-model="activeTab" type="card">
            <el-tab-pane label="总计" name="tab1">
              <el-table v-loading="loading" :data="totalStatsList" border stripe>
                <el-table-column prop="日期" label="日期" width="140"></el-table-column>
                <el-table-column prop="套餐" label="套餐" width="450"></el-table-column>
                <el-table-column prop="份数" label="份数" width="60"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="班级汇总" name="tab2">
              <el-table v-loading="loading" :data="classCountStatsArray" border stripe>
                <el-table-column prop="班级" label="班级" width="140"></el-table-column>
                <el-table-column v-for="(classCountStatsTitle, index) in classCountStatsTitleArray" :key="index" :prop="classCountStatsTitle" :label="classCountStatsTitle" width="120"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-for="(statsList, dateAndPart) in dateAndPartToStatsListMap" :key="dateAndPart" :label="dateAndPart" :name="dateAndPart">
              <el-table v-loading="loading" :data="statsList" border stripe>
                <el-table-column prop="班级" label="班级" width="65"></el-table-column>
                <el-table-column prop="套餐" label="套餐" width="350"></el-table-column>
                <el-table-column prop="份数" label="份数" width="60"></el-table-column>
                <el-table-column prop="名单" label="名单" width="450"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane v-for="(statsList, className) in classNameToDatePartStatsListMap" :key="className" :label="className" :name="className">
              <el-table v-loading="loading" :data="statsList" border stripe>
                <el-table-column prop="套餐" label="套餐" width="210"></el-table-column>
                <el-table-column prop="份数" label="份数" width="50"></el-table-column>
                <el-table-column prop="名单" label="名单" width="649"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          let todaysZero = new Date()
          // todaysZero.setHours(0, 0, 0, 0)
          return time.getTime() < todaysZero
        }
      },
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: null,
        status: ''
      },
      addData: {
        schoolId: null
      },
      addDialogVisible: false,
      modifyData: {
        schoolId: null
      },
      modifyDialogVisible: false,
      rules: {
        startDate: [{ required: true, message: '请选择学生就餐日期（开始）', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择学生就餐日期（结束）', trigger: 'change' }],
        bookTime: [{ required: true, message: '请选择家长点餐时间（开始）', trigger: 'change' }],
        lockTime: [{ required: true, message: '请选择家长点餐时间（结束）', trigger: 'change' }]
      },
      statsDialogVisible: false,
      totalStatsList: [],
      classCountStatsArray: [],
      classCountStatsTitleArray: [],
      dateAndPartToStatsListMap: {},
      classNameToDatePartStatsListMap: {},
      activeTab: 'tab1',
      selectedWeekMenuId: null
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getStudentCanteenScheduleList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getStudentCanteenScheduleList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStudentCanteenScheduleList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenMenu/list', {
        schoolId: _this.searchForm.schoolId,
        page: _this.currentPage,
        size: _this.pageSize
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addStudentCanteenSchedule () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          _this.addData.schoolId = _this.searchForm.schoolId
          _this.addData.bookTime = _this.addData.bookTime + ' 00:00:00'
          _this.addData.lockTime = _this.addData.lockTime + ' 23:40:00'
          this.$axios.post(this.GLOBAL.host + '/studentCanteenMenu/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getStudentCanteenScheduleList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openModifyDialog (canteenScheduleData) {
      // console.log(canteenGoodsData)
      this.modifyData = JSON.parse(JSON.stringify(canteenScheduleData))
      this.modifyDialogVisible = true
    },
    modifyStudentCanteenSchedule () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          _this.modifyData.schoolId = _this.searchForm.schoolId
          _this.modifyData.bookTime = _this.modifyData.bookTime + ' 00:00:00'
          _this.modifyData.lockTime = _this.modifyData.lockTime + ' 23:40:00'
          this.$axios.post(this.GLOBAL.host + '/studentCanteenMenu/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getStudentCanteenScheduleList()
                _this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openStatsDialog (canteenScheduleData) {
      if (!canteenScheduleData || !canteenScheduleData.id) return
      this.statsDialogVisible = true
      this.selectedWeekMenuId = canteenScheduleData.id
      // console.log(canteenScheduleData)
      this.totalStatsList = []
      this.dateAndPartToStatsListMap = {}
      this.classCountStatsTitleArray = []
      this.statsByWeekMenuId(canteenScheduleData.id)
    },
    statsByWeekMenuId (weekMenuId) {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenOrder/statsByWeekMenuId', {
        weekMenuId: weekMenuId
      }).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null) {
              _this.totalStatsList = res.data.data.totalStatsList
              _this.classCountStatsArray = res.data.data.classCountStatsArray
              for (var key in _this.classCountStatsArray[0]) {
                if (!_this.classCountStatsArray[0].hasOwnProperty(key)) continue
                if (key !== '班级') {
                  _this.classCountStatsTitleArray.push(key)
                }
              }
              _this.dateAndPartToStatsListMap = res.data.data.dateAndPartToStatsListMap
              _this.classNameToDatePartStatsListMap = res.data.data.classNameToDatePartStatsListMap
            } else {
              _this.dateAndPartToStatsListMap = {}
              _this.classNameToDatePartStatsListMap = {}
            }
          } else {
            this.$message.error(res.data.message)
            _this.dateAndPartToStatsListMap = {}
            _this.classNameToDatePartStatsListMap = {}
          }
        }
        _this.loading = false
      })
    },
    downloadStatsByWeekMenuId (weekMenuId) {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/studentCanteenOrder/downloadStatsByWeekMenuId', {
        weekMenuId: _this.selectedWeekMenuId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StudentCanteenSchedule.vue